module.exports = __webpack_public_path__ + "img/6.e5c2eebc.svg";